/* tslint:disable */
/* eslint-disable */
/**
 * MTX Brokerage API
 * Brokerage agent-facing API for dispositions, listings, and transactions
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * "Talk to a real estate advisor" (TXN-3529): the same contact and consent as the interest form. It records the
 * contact and consent, not interest, and asks Mainstay to call the resident.
 * @export
 * @interface HomeownershipAdvisorRequest
 */
export interface HomeownershipAdvisorRequest {
    /**
     * 
     * @type {string}
     * @memberof HomeownershipAdvisorRequest
     */
    token: string;
    /**
     * 
     * @type {string}
     * @memberof HomeownershipAdvisorRequest
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof HomeownershipAdvisorRequest
     */
    email: string;
    /**
     * 
     * @type {string}
     * @memberof HomeownershipAdvisorRequest
     */
    phone?: string;
    /**
     * 
     * @type {boolean}
     * @memberof HomeownershipAdvisorRequest
     */
    consentAccepted: boolean;
}

/**
 * Check if a given object implements the HomeownershipAdvisorRequest interface.
 */
export function instanceOfHomeownershipAdvisorRequest(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "token" in value;
    isInstance = isInstance && "name" in value;
    isInstance = isInstance && "email" in value;
    isInstance = isInstance && "consentAccepted" in value;

    return isInstance;
}

export function HomeownershipAdvisorRequestFromJSON(json: any): HomeownershipAdvisorRequest {
    return HomeownershipAdvisorRequestFromJSONTyped(json, false);
}

export function HomeownershipAdvisorRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): HomeownershipAdvisorRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'token': json['token'],
        'name': json['name'],
        'email': json['email'],
        'phone': !exists(json, 'phone') ? undefined : json['phone'],
        'consentAccepted': json['consent_accepted'],
    };
}

export function HomeownershipAdvisorRequestToJSON(value?: HomeownershipAdvisorRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'token': value.token,
        'name': value.name,
        'email': value.email,
        'phone': value.phone,
        'consent_accepted': value.consentAccepted,
    };
}

